import { Category, useAlert } from '@drawbotics/react-drylus';
import { RouterService } from '@tokamakjs/common';
import { Controller, onDidMount, state, useAppContext } from '@tokamakjs/react';

import { ChangePasswordError } from '~/api/auth.api';
import { AuthService } from '~/services';
import { AppContext } from '~/types';
import { createTranslate } from '~/utils';

import { ResetPasswordView } from './reset-password.view';

const tt = createTranslate('routes.reset_password');

@Controller({ view: ResetPasswordView })
export class ResetPasswordController {
  private _appContext = useAppContext<AppContext>();
  private _showAlert = useAlert().showAlert;

  @state code: string | null;

  @state isSendingResetRequest = false;
  @state resetRequestSent = false;

  @state isChangingPassword = false;

  constructor(private _router: RouterService, private _authService: AuthService) {
    this.code = this._router.query.get('code');
  }

  @onDidMount()
  onDidMount() {
    const user = this._authService.getUserFromLocalToken();
    if (user != null) {
      this._appContext.onFinish();
    }
  }

  async sendResetRequest(value: { email: string }) {
    this.isSendingResetRequest = true;

    const res = await this._authService.sendPasswordResetRequest(value);

    if (res.error) {
      this._showAlert({
        text: tt('request_reset_sidebar.generic_reset_error'),
        category: Category.DANGER,
      });
    } else {
      this.resetRequestSent = true;
    }

    this.isSendingResetRequest = false;
  }

  async changePassword(values: { password: string }) {
    if (this.code == null || this.code === '') {
      throw new Error();
    }

    this.isChangingPassword = true;

    const res = await this._authService.changePassword({
      password: values.password,
      code: this.code,
    });

    if (res.error != null) {
      this.isChangingPassword = false;

      if (res.error === ChangePasswordError.LINK_NOT_RECOGNIZED) {
        this._showAlert({
          text: tt('change_password_sidebar.link_not_recognized_error'),
          category: Category.DANGER,
        });
      } else if (res.error === ChangePasswordError.GENERIC) {
        this._showAlert({
          text: tt('change_password_sidebar.generic_reset_error'),
          category: Category.DANGER,
        });
      }
    } else {
      this._showAlert({
        text: tt('change_password_sidebar.success'),
        category: Category.SUCCESS,
      });
      setTimeout(() => {
        this._router.push('../login');
      }, 2000);
    }
  }
}
